export default __webpack_public_path__ + "static/media/link.86df731b.svg";